import { createTheme } from "@mui/material";
export const primaryTheme = createTheme({
  palette: {
    primary: {
      main: '#0061afcf',
    },
    secondary: {
      main: '#747373',
    },
    mode: "light",
  },
});